import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import Bugsnag from '@bugsnag/js'
import { useMutation, useQueryClient } from 'react-query'
import { useQuery } from 'react-query'
import ReinviteDataTable from '../components/ReinviteDataTable'

// API
import { postReinviteStaff } from 'services/api/modules/staff-management/staffManagementDashboard'
import { getUninvitedStaffData } from 'services/api/modules/staff-management/staffManagementDashboard'
import AdxButton from 'components/custom/AdxButton'

const ReinviteStaff = () => {
  const queryClient = useQueryClient()
  const {
    // isLoading,
    // error,
    data: uninvitedStaffData,
  } = useQuery('getUninvitedStaff', async () => {
    const { data } = await getUninvitedStaffData()
    return data
  })

  const { mutate } = useMutation((value) => postReinviteStaff(value), {
    onSuccess: () => {
      setPageState('SUCCESSFUL_REQUEST')
      queryClient.invalidateQueries('getUninvitedStaff')
    },
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })

  const navigate = useNavigate()
  const [pageState, setPageState] = useState('FILL_DETAILS')
  const [data, setData] = useState([])

  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  if (pageState === 'SUCCESSFUL_REQUEST') {
    return (
      <AdxInfoModal
        open={true}
        muiIcon="group_add"
        iconColor="alternate.main"
        title="Staff Invited"
        subtitle={`Your staff has been invited through the email registered. You can check with them to verify the registration.`}
        modalWidth="500px"
        footerButtons
        firstBtnLabel={'Close'}
        firstBtnHandle={() => navigate(-1)}
      ></AdxInfoModal>
    )
  }
  return (
    <AdxFormModal
      open={true}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      disableEscapeKeyDown
      disableAutoFocus
      sxModal={{
        minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '1000px' },
        width: { xs: 'calc(100vw - 30px)', lg: 'calc(100vw - 1500px)' },
      }}
      title="Resend invitation"
      subtitle={null}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1">
            There {uninvitedStaffData.length > 1 ? 'are' : 'is'} {uninvitedStaffData?.length}{' '}
            inactive staff in your organization. You may resend the invitation link to them by email
          </Typography>
          <ReinviteDataTable staffData={uninvitedStaffData} data={data} setData={setData} />
        </Box>
        <Box
          width={1}
          sx={{
            rowGap: 1,
            columnGap: 1,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            justifyContent: 'flex-end',
          }}
        >
          <AdxButton
            variant={'outlined'}
            onClick={handleCloseModal}
            sx={{ width: { xs: '100%', lg: '15%' } }}
          >
            Cancel
          </AdxButton>
          <AdxButton
            variant={'contained'}
            onClick={() => {
              const result = { staff: `[${data.toString()}]` }
              mutate(result)
            }}
            disabled={data?.length === 0 ? true : false}
            sx={{ width: { xs: '100%', lg: '20%' } }}
          >
            Invite ({data?.length})
          </AdxButton>
        </Box>
      </Box>
    </AdxFormModal>
  )
}

export default ReinviteStaff
